import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// dashboard routing
//const DashboardDefault = Loadable(lazy(() => import('views/dashboard/mainDashboard')));
import DashboardDefault from 'views/dashboard/mainDashboard';
//Paginas routing
const Employees = Loadable(lazy(() => import('views/pages/administrator/admins/Employees')));
const Admins = Loadable(lazy(() => import('views/pages/administrator/admins/Admins')));
const ProductionGoal = Loadable(lazy(() => import('views/pages/administrator/admins/ProductionGoal')));

const ExportTicket = Loadable(lazy(() => import('views/pages/administrator/export/ExportTickets')));
const ExportProduction = Loadable(lazy(() => import('views/pages/administrator/export/ExportProduction')));

//Catalogs
const CorrectionType = Loadable(lazy(() => import('views/pages/administrator/catalog/CorrectionType')));
const DownTimeType = Loadable(lazy(() => import('views/pages/administrator/catalog/DownTimeType')));
const FactoryC = Loadable(lazy(() => import('views/pages/administrator/catalog/Factory')));
const Machine = Loadable(lazy(() => import('views/pages/administrator/catalog/Machine')));
const ProductionFloor = Loadable(lazy(() => import('views/pages/administrator/catalog/ProductionFloor')));
const ProductionLine = Loadable(lazy(() => import('views/pages/administrator/catalog/ProductionLine')));
const Shift = Loadable(lazy(() => import('views/pages/administrator/catalog/Shift')));
const ShiftExtra = Loadable(lazy(() => import('views/pages/administrator/catalog/ShiftExtra')));
const Product = Loadable(lazy(() => import('views/pages/administrator/catalog/Product')));
const DefectType = Loadable(lazy(() => import('views/pages/administrator/catalog/DefectType')));

const Profile = Loadable(lazy(() => import('views/pages/users/profile/Profile')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            path: '/',
            element: <DashboardDefault />
        },
        {
            path: 'dashboard',
            children: [
                {
                    path: 'default',
                    element: <DashboardDefault />
                }
            ]
        },
        {
            path: 'export',
            children: [
                {
                    path: 'tickets',
                    element: <ExportTicket />
                },
                {
                    path: 'production',
                    element: <ExportProduction />
                }
            ]
        },
        {
            path: 'admin',
            children: [
                {
                    path: 'users',
                    element: <Employees />
                },
                {
                    path: 'all',
                    element: <Admins />
                },
                {
                    path: 'production-goal',
                    element: <ProductionGoal />
                }
            ]
        },
        {
            path: 'catalog',
            children: [
                {
                    path: 'shift',
                    element: <Shift />
                },
                {
                    path: 'shift-extra',
                    element: <ShiftExtra />
                },
                {
                    path: 'factory',
                    element: <FactoryC />
                },
                {
                    path: 'product',
                    element: <Product />
                },
                {
                    path: 'production-floor',
                    element: <ProductionFloor />
                },
                {
                    path: 'production-line',
                    element: <ProductionLine />
                },
                {
                    path: 'machine',
                    element: <Machine />
                },
                {
                    path: 'defects',
                    element: <DefectType />
                },
                {
                    path: 'down-time-type',
                    element: <DownTimeType />
                },
                {
                    path: 'correction-type',
                    element: <CorrectionType />
                }
            ]
        },
        {
            path: '*',
            element: <DashboardDefault />
        }
    ]
};

export default MainRoutes;
